import { ReservationStatus } from "@/types/reservation";

export const RESERVATION_STATUS_FILTER_DEFAULT = "all statuses";

export const RESERVATION_STATUS_FILTER_OPTIONS = [
  {
    value: "active",
    label: "Active",
    statuses: [
      ReservationStatus.PENDING,
      ReservationStatus.CONFIRMED,
      ReservationStatus.CHECKED_IN,
    ],
  },
  {
    value: "canceled",
    label: "Canceled",
    statuses: [ReservationStatus.CANCELLED],
  },
  {
    value: "inactive",
    label: "Inactive",
    statuses: [ReservationStatus.CHECKED_OUT],
  },
] as const;

export type ReservationStatusFilter =
  (typeof RESERVATION_STATUS_FILTER_OPTIONS)[number]["value"];

export function mapReservationStatusFilterToStatuses(
  value: string,
): ReservationStatus[] {
  const option = RESERVATION_STATUS_FILTER_OPTIONS.find(
    (item) => item.value === value,
  );

  return option ? [...option.statuses] : [];
}
